import { AccountingSystem } from '../../entities';
import { Entity } from '../entity';
import { Lex, PagingOptions } from '../shared';
import { PaymentMethodEntity, PaymentSource, PaymentStatus, PaymentType } from './payment';
import { PaymentViewFilters } from './payment.filters';

export enum PaymentViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum PaymentSystemViewName {
    MyPayments = 'My Payments',
}

export type PaymentViewSortType = 'ASC' | 'DESC';

export enum PaymentViewSortBy {
    None = 'none',
    AccountName = 'account.name',
    CompanyName = 'company.name',
    PaymentDate = 'date',
    PaymentMethod = 'method.name',
    ReceivedBy = 'receiver.name',
}

export interface PaymentViewSortOptions {
    sortBy: PaymentViewSortBy;
    sortType: PaymentViewSortType;
}

export interface PaymentSummary {
    _id: string;
    date: Date;
    amount: number;
    receiver: Entity;
    method: PaymentMethodEntity;
    type: PaymentType;
    entity: Entity;
    reference: string;
    status: PaymentStatus;
    company: Entity;
    account: Entity;
    note: string;
    accountGroup?: string;
    methodGroup?: string;
    path?: string[];
    source?: PaymentSource;
}

export interface PaymentViewRequest {
    sort: PaymentViewSortOptions;
    view: any;
    filters: PaymentViewFilters;
    paging: PagingOptions;
    type?: PaymentType;
}


export interface PaymentViewResponse {
    views: any[];
    columns: any[];
    pageTotal: number;
    total: number;
    payments: PaymentSummary[];
    paging: PagingOptions
}


export interface PaymentViewCardFields {
    projectNumber: boolean;
    status: boolean;
    account: boolean;
    owner: boolean;
    start: boolean;
    end: boolean;
    type: boolean;
    tags: boolean;
    contact: boolean;
    address: boolean;
    customFields: Entity[];
}

export interface PaymentViewListField {
    _id: string;
    name: string;
    visible: boolean;
    sortOrder: Lex;
    system: boolean;
}

export interface PaymentView extends Entity {

    description: string;
    visibility?: PaymentViewVisibility;
    sharedWith?: Entity[];
    type: PaymentType;

    owner: Entity;
    system?: boolean;

    filters: PaymentViewFilters;
    sort?: PaymentViewSortOptions;

    canEditView?: boolean;
    canShareView?: boolean;

}

export interface PaymentViewSummary {
    _id: string;
    name: string;
    visibility: PaymentViewVisibility;
    type: PaymentType;
    sort?: PaymentViewSortOptions;
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    ownerId?: string;
    canEditView?: boolean;
    sharedWith: Entity[]
    filters?: PaymentViewFilters;
    accountingSystem?: AccountingSystem;
}

export function emptyPaymentView(data?: Partial<PaymentView>) {
    return {
        name: null,
        description: null,
        type: PaymentType.Receivable,
        visibility: PaymentViewVisibility.Private,
        sharedWith: [],
        filters: {},
        ...data,
    } as PaymentView;
}